// Analytics event names for Settings › Facilities — must stay byte-for-byte equal to the PRD table
// (Mixpanel/Pendo dashboards key on them). Fired through useStandardizedTracking so they reach
// Pendo, Mixpanel and the backend relay with user_role / site context attached.
export const FACILITY_FEATURE_GROUP = "settings";
export const FACILITY_PAGE_KEY = "settings_facilities";

export const FACILITY_EVENTS = Object.freeze({
  PAGE_VIEWED: "settings_facilities_viewed",
  DETAIL_VIEWED: "settings_facility_detail_viewed",
  EDIT_STARTED: "settings_facility_edit_started",
  EDIT_SAVED: "settings_facility_edit_saved",
  EDIT_CANCELLED: "settings_facility_edit_cancelled",
  SEARCHED: "settings_facilities_searched",
  EXPORT_CLICKED: "settings_facilities_export_clicked",
  EXPORT_SUCCEEDED: "settings_facilities_export_succeeded",
  EXPORT_FAILED: "settings_facilities_export_failed",
  UNSAVED_CHANGES_SHOWN: "settings_facility_unsaved_changes_shown",
  UNSAVED_CHANGES_DISCARDED: "settings_facility_unsaved_changes_discarded"
});
